module.exports = __webpack_public_path__ + "static/media/inbox-out.7bd401de.svg";